/**
 * API服务配置
 * 使用统一的配置管理
 */
import { getApiUrl, buildApiUrl, buildFileUrl } from '@/config';

// 导出配置的API URL (包含/api路径)
export const API_URL = getApiUrl();

// 导出便捷方法
export { getApiUrl, buildApiUrl };

// 如果你使用axios，可以创建一个预配置的axios实例
import axios from 'axios';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Clipboard service for clipboard operations
export const clipboardService = {
  // Create a new clipboard
  createClipboard(name = 'Untitled Clipboard', content = '') {
    return apiClient.post(`/api/clipboards`, { name, content });
  },
  
  getClipboard(clipboardId) {
    return apiClient.get(`/api/clipboards/${clipboardId}`);
  },
  
  updateClipboard(clipboardId, data) {
    return apiClient.put(`/api/clipboards/${clipboardId}`, data);
  },
  
  getEntries(clipboardId) {
    return apiClient.get(`/api/clipboards/${clipboardId}/entries`);
  },
  
  addEntry(clipboardId, content, contentType, name = '') {
    return apiClient.post(`/api/clipboards/${clipboardId}/entries`, { content, contentType, name });
  },
  
  deleteEntry(uniqueId) {
    return apiClient.delete(`/api/entries/${uniqueId}`);
  },
  
  updateEntry(uniqueId, content, contentType, name = '') {
    return apiClient.put(`/api/entries/${uniqueId}`, { content, contentType, name });
  }
};

// File service for file operations
export const fileService = {
  // Upload files to a clipboard
  uploadFiles(clipboardId, formData, onUploadProgress) {
    return apiClient.post(`/api/clipboards/${clipboardId}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 3600000,
      onUploadProgress
    });
  },
  
  // Get all files for a clipboard
  getFiles(clipboardId) {
    return apiClient.get(`/api/clipboards/${clipboardId}/files`);
  },
  
  // Delete a file by unique ID
  deleteFile(fileUniqueId) {
    return apiClient.delete(`/api/files/${fileUniqueId}`);
  },
  
  // Get file content for preview (text files)
  getFileContent(fileUniqueId) {
    return axios.get(buildFileUrl(fileUniqueId, true), {
      responseType: 'text'
    });
  },
  
  // Update file metadata (name and content description)
  updateFileInfo(fileUniqueId, name, content) {
    return apiClient.put(`/api/files/${fileUniqueId}/info`, { name, content });
  }
};

// Entry service for individual entry operations
export const entryService = {
  // Get entry content (raw text)
  getEntry(uniqueId) {
    return apiClient.get(`/api/entries/${uniqueId}`);
  },
  
  // Get entry info (metadata + content)
  getEntryInfo(uniqueId) {
    return apiClient.get(`/api/entries/${uniqueId}/info`);
  }
};

export default apiClient; 